import { combineReducers } from 'redux';
import LoginReducer from './login';
import BlogReducer from './blog';

const rootReducer = combineReducers({
    login: LoginReducer,
    blog: BlogReducer
});

export default rootReducer;